import { useTranslation } from "react-i18next"

import { Crown, Users } from "@/components/icons"

import { PersonPicker, type PickedPerson } from "./person-picker"
import { useTenderHandoffConfig } from "../hooks/use-tender-cases"

/**
 * Ansvarig + deltagare on the new-case form.
 *
 * Both optional, and both changeable later in Setup — naming someone here
 * records intent, it does not hand the case over.
 */
export function QuickStartPeopleFields({
  responsible,
  onResponsibleChange,
  participants,
  onParticipantsChange,
  disabled = false,
}: {
  responsible: PickedPerson[]
  onResponsibleChange: (next: PickedPerson[]) => void
  participants: PickedPerson[]
  onParticipantsChange: (next: PickedPerson[]) => void
  disabled?: boolean
}) {
  const { t } = useTranslation()
  const { data: handoffConfig } = useTenderHandoffConfig()
  const scopeGroup = handoffConfig?.userGroupId ?? undefined

  return (
    <>
      <PersonPicker
        disabled={disabled}
        hint={t("tender.people.responsibleHint")}
        icon={<Crown className="text-muted-foreground size-4 shrink-0" />}
        label={t("tender.people.responsibleLabel")}
        placeholder={t("tender.people.responsiblePlaceholder")}
        scopeGroup={scopeGroup}
        selected={responsible}
        onChange={onResponsibleChange}
      />
      <PersonPicker
        multiple
        dimmedOids={responsible.map((p) => p.oid)}
        disabled={disabled}
        hint={t("tender.people.participantsHint")}
        icon={<Users className="text-muted-foreground size-4 shrink-0" />}
        label={t("tender.people.participantsLabel")}
        placeholder={t("tender.people.participantsPlaceholder")}
        scopeGroup={scopeGroup}
        selected={participants}
        onChange={onParticipantsChange}
      />
    </>
  )
}
